import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login berhasil");
      nav("/");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left visual - company logo */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden border-r border-neutral-800 bg-white items-center justify-center">
        <div className="absolute inset-0 grid-pattern opacity-30"></div>
        <div className="relative z-10 flex flex-col items-center px-12">
          <img
            src="/logo-ppp.jpg"
            alt="PT. Putra Bungsu Perkasa Papua"
            className="w-full max-w-md object-contain"
          />
          <div className="mt-8 text-center">
            <div className="inline-block px-3 py-1 border border-[#FF6600] bg-[#FF6600] text-black font-mono text-xs">
              ERP • TAMBANG • v1.0
            </div>
            <p className="text-neutral-700 max-w-md mt-4 text-sm">
              Sistem operasi tambang terintegrasi — Absensi, Aset, Produksi, Keuangan.
            </p>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className="flex-1 flex items-center justify-center px-6 bg-[#0A0A0A]">
        <form onSubmit={submit} className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex justify-center mb-8">
            <div className="bg-white p-4 border border-neutral-800">
              <img src="/logo-ppp.jpg" alt="PT. Putra Bungsu Perkasa Papua" className="h-24 object-contain" />
            </div>
          </div>
          <div className="mb-10">
            <div className="font-mono text-xs text-[#FF6600] mb-2">// SIGN IN</div>
            <h2 className="font-display font-black text-4xl text-white mb-2">Masuk ke Sistem</h2>
            <p className="text-neutral-400 text-sm">PT. Putra Bungsu Perkasa Papua</p>
          </div>

          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs font-mono uppercase text-neutral-400 tracking-wider">Email</Label>
              <Input
                id="email" type="email" data-testid="login-email-input"
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="nama@perusahaan.co.id"
                autoComplete="username"
                className="mt-2 bg-neutral-900 border-neutral-800 rounded-none h-12 focus:border-[#FF6600] focus:ring-0"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs font-mono uppercase text-neutral-400 tracking-wider">Password</Label>
              <Input
                id="password" type="password" data-testid="login-password-input"
                value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                className="mt-2 bg-neutral-900 border-neutral-800 rounded-none h-12 focus:border-[#FF6600] focus:ring-0"
                required
              />
            </div>
            <Button
              type="submit" data-testid="login-submit-button" disabled={loading}
              className="w-full h-12 rounded-none bg-[#FF6600] text-black font-bold hover:bg-[#ff7a1a]"
            >
              {loading ? "MEMPROSES..." : "MASUK →"}
            </Button>
          </div>

          <div className="mt-10 pt-6 border-t border-neutral-800">
            <div className="font-mono text-[11px] text-neutral-500 text-center">
              © 2026 PT. Putra Bungsu Perkasa Papua
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
